import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lastList: [
      {
        nums: '',
        name: '练习1/6'
      },
      {
        nums: '',
        name: '练习2/6'
      },
      {
        nums: '',
        name: '练习3/6'
      },
      {
        nums: '',
        name: '练习4/6'
      },
      {
        nums: '',
        name: '练习5/6'
      },
      {
        nums: '',
        name: '练习6/6'
      },
      {
        ids: 0,
        nums: '',
        name: '1/92'
      },
      {
        ids: 1,
        nums: '',
        name: '2/92'
      },
      {
        ids: 2,
        nums: '',
        name: '3/92'
      },
      {
        ids: 3,
        nums: '',
        name: '4/92'
      },
      {
        ids: 4,
        nums: '',
        name: '5/92'
      },
      {
        ids: 5,
        nums: '',
        name: '6/92'
      },
      {
        ids: 6,
        nums: '',
        name: '7/92'
      },
      {
        ids: 7,
        nums: '',
        name: '8/92'
      },
      {
        ids: 8,
        nums: '',
        name: '9/92'
      },
      {
        ids: 9,
        nums: '',
        name: '10/92'
      },
      {
        ids: 10,
        nums: '',
        name: '11/92'
      },
      {
        ids: 11,
        nums: '',
        name: '12/92'
      },
      {
        ids: 12,
        nums: '',
        name: '13/92'
      },
      {
        ids: 13,
        nums: '',
        name: '14/92'
      },
      {
        ids: 14,
        nums: '',
        name: '15/92'
      },
      {
        ids: 15,
        nums: '',
        name: '16/92'
      },
      {
        ids: 16,
        nums: '',
        name: '17/92'
      },
      {
        ids: 17,
        nums: '',
        name: '18/92'
      },
      {
        ids: 18,
        nums: '',
        name: '19/92'
      },
      {
        ids: 19,
        nums: '',
        name: '20/92'
      },
      {
        ids: 20,
        nums: '',
        name: '21/92'
      },
      {
        ids: 21,
        nums: '',
        name: '22/92'
      },
      {
        ids: 22,
        nums: '',
        name: '23/92'
      },
      {
        ids: 23,
        nums: '',
        name: '24/92'
      },
      {
        ids: 24,
        nums: '',
        name: '25/92'
      },
      {
        ids: 25,
        nums: '',
        name: '26/92'
      },
      {
        ids: 26,
        nums: '',
        name: '27/92'
      },
      {
        ids: 27,
        nums: '',
        name: '28/92'
      },
      {
        ids: 28,
        nums: '',
        name: '29/92'
      },
      {
        ids: 29,
        nums: '',
        name: '30/92'
      },
      {
        ids: 30,
        nums: '',
        name: '31/92'
      },
      {
        ids: 31,
        nums: '',
        name: '32/92'
      },
      {
        ids: 32,
        nums: '',
        name: '33/92'
      },
      {
        ids: 32,
        nums: '',
        name: '34/92'
      },
      {
        ids: 34,
        nums: '',
        name: '35/92'
      },
      {
        ids: 35,
        nums: '',
        name: '36/92'
      },
      {
        ids: 36,
        nums: '',
        name: '37/92'
      },
      {
        ids: 37,
        nums: '',
        name: '38/92'
      },
      {
        ids: 38,
        nums: '',
        name: '39/92'
      },
      {
        ids: 39,
        nums: '',
        name: '40/92'
      },
      {
        ids: 40,
        nums: '',
        name: '41/92'
      },
      {
        ids: 41,
        nums: '',
        name: '42/92'
      },
      {
        ids: 42,
        nums: '',
        name: '43/92'
      },
      {
        ids: 43,
        nums: '',
        name: '44/92'
      },
      {
        ids: 44,
        nums: '',
        name: '45/92'
      },
      {
        ids: 45,
        nums: '',
        name: '46/92'
      },
      {
        ids: 46,
        nums: '',
        name: '47/92'
      },
      {
        ids: 47,
        nums: '',
        name: '48/92'
      },
      {
        ids: 48,
        nums: '',
        name: '49/92'
      },
      {
        ids: 49,
        nums: '',
        name: '50/92'
      },
      {
        ids: 50,
        nums: '',
        name: '51/92'
      },
      {
        ids: 51,
        nums: '',
        name: '52/92'
      },
      {
        ids: 52,
        nums: '',
        name: '53/92'
      },
      {
        ids: 53,
        nums: '',
        name: '54/92'
      },
      {
        ids: 54,
        nums: '',
        name: '55/92'
      },
      {
        ids: 55,
        nums: '',
        name: '56/92'
      },
      {
        ids: 56,
        nums: '',
        name: '57/92'
      },
      {
        ids: 57,
        nums: '',
        name: '58/92'
      },
      {
        ids: 58,
        nums: '',
        name: '59/92'
      },
      {
        ids: 59,
        nums: '',
        name: '60/92'
      },
      {
        ids: 60,
        nums: '',
        name: '61/92'
      },
      {
        ids: 61,
        nums: '',
        name: '62/92'
      },
      {
        ids: 62,
        nums: '',
        name: '63/92'
      },
      {
        ids: 63,
        nums: '',
        name: '64/92'
      },
      {
        ids: 64,
        nums: '',
        name: '65/92'
      },
      {
        ids: 65,
        nums: '',
        name: '66/92'
      },
      {
        ids: 66,
        nums: '',
        name: '67/92'
      },
      {
        ids: 67,
        nums: '',
        name: '68/92'
      },
      {
        ids: 68,
        nums: '',
        name: '69/92'
      },
      {
        ids: 69,
        nums: '',
        name: '70/92'
      },
      {
        ids: 70,
        nums: '',
        name: '71/92'
      },
      {
        ids: 71,
        nums: '',
        name: '72/92'
      },
      {
        ids: 72,
        nums: '',
        name: '73/92'
      },
      {
        ids: 73,
        nums: '',
        name: '74/92'
      },
      {
        ids: 74,
        nums: '',
        name: '75/92'
      },
      {
        ids: 75,
        nums: '',
        name: '76/92'
      },
      {
        ids: 76,
        nums: '',
        name: '77/92'
      },
      {
        ids: 77,
        nums: '',
        name: '78/92'
      },
      {
        ids: 78,
        nums: '',
        name: '79/92'
      },
      {
        ids: 79,
        nums: '',
        name: '80/92'
      },
      {
        ids: 80,
        nums: '',
        name: '81/92'
      },
      {
        ids: 81,
        nums: '',
        name: '82/92'
      },
      {
        ids: 82,
        nums: '',
        name: '83/92'
      },
      {
        ids: 83,
        nums: '',
        name: '84/92'
      },
      {
        ids: 84,
        nums: '',
        name: '85/92'
      },
      {
        ids: 85,
        nums: '',
        name: '86/92'
      },
      {
        ids: 86,
        nums: '',
        name: '87/92'
      },
      {
        ids: 87,
        nums: '',
        name: '88/92'
      },
      {
        ids: 88,
        nums: '',
        name: '89/92'
      },
      {
        ids: 89,
        nums: '',
        name: '90/92'
      },
      {
        ids: 90,
        nums: '',
        name: '91/92'
      },
      {
        ids: 91,
        nums: '',
        name: '92/92'
      },


    ],
    times: ''
  },
  mutations: {
    setLast(state, payload) {
      state.lastList = payload
      console.log(state.lastList);
    },
    setTimes(state, payload) {
      state.times = payload
      console.log(state.times);
    }
  },
  actions: {
  },
  modules: {
  }
})
